module.exports = __webpack_public_path__ + "static/marchi-calici-763a62ef9a75d5fd8c8f9b6443070659.jpg";